/* import __COLOCATED_TEMPLATE__ from './edit-sh-billable-line-item-modal.hbs'; */
import { inject as service } from '@ember/service';
import LSGModalBase from "../lsg/lsg-modal-dialog-base";
import { SH_BILLABLE_LINE_ITEM } from "../../../models/sh-billable-line-item";
import { closeModal } from 'sh-www/utils/modal-controls';

export default LSGModalBase.extend({
  /**
   * Register services
   */
  shInvoiceLineItemsCommandService : service('commands/sh-invoice-line-item-commands'),
  shPaymentLineItemsCommandService : service('commands/sh-payment-line-item-commands'),

  /**
   * @inheritDoc
   */
  propertyDefaults: {
    /**
     * NOTE --- This param is mutually exclusive with shPayment
     *
     * @param {ShInvoice}
     */
    shInvoice: null,

    /**
     * This will turn on the edit mode for the modal.
     *
     * NOTE --- when you pass this in, shInvoice must be available and shPayment must be empty.
     *
     * @param {ShInvoiceLineItem}
     */
    shInvoiceLineItem: null,

    /**
     * NOTE --- This param is mutually exclusive with shInvoice
     *
     * @param {ShPayment}
     */
    shPayment: null,

    /**
     * @type {Function}     Called after we have successfully added a line item in the DB.
     */
    onAddLineItemAdded: () => {}
  },

  /**
   * @inheritDoc
   */
  stateDefaults: {
    /**
     * @type {Number}
     */
    amount: null,

    /**
     * @type {String}
     */
    description: '',

    /**
     * @type {Boolean}
     */
    isUpdating: false
  },

  /**
   * @inheritDoc
   */
  _onInitializationComplete() {
    let shInvoiceLineItem = this.get('model.shInvoiceLineItem');
    if (!shInvoiceLineItem) {
      return;
    }

    this.set('state.amount', shInvoiceLineItem.get('amount'));
    this.set('state.description', shInvoiceLineItem.get('description'));
  },

  actions: {
    handleClose() {
      closeModal(this);
    },

    /**
     *
     */
    onAddLineItemClicked: function() {
      this.set('state.isUpdating', true);

      if (this.get('model.shInvoiceLineItem')) {
        this.get('shInvoiceLineItemsCommandService').updateInvoiceLineItem(
          this.get('model.shInvoiceLineItem'),
          this.get('state.amount'),
          this.get('state.description')
        ).then(() => {
          closeModal(this);
          this.get('model.onAddLineItemAdded')();
        }).catch(() => {
          // gobble gobble
        }).finally(() => this.set('state.isUpdating', false));
        return;
      }

      if (this.get('model.shPayment')) {
        this.get('shPaymentLineItemsCommandService').addPaymentLineItem(
          this.get('model.shPayment'),
          SH_BILLABLE_LINE_ITEM.TYPES.ADJUSTMENT,
          this.get('state.amount'),
          this.get('state.description')
        ).then(() => {
          closeModal(this);
          this.get('model.onAddLineItemAdded')();
        }).catch(() => {
          // gobble gobble
        }).finally(() => this.set('state.isUpdating', false));

        return;
      }

      this.get('shInvoiceLineItemsCommandService').addInvoiceLineItem(
        this.get('model.shInvoice'),
        SH_BILLABLE_LINE_ITEM.TYPES.ADJUSTMENT,
        this.get('state.amount'),
        this.get('state.description')
      ).then(() => {
        closeModal(this);
        this.get('model.onAddLineItemAdded')();
      }).catch(() => {
        // gobble gobble
      }).finally(() => this.set('state.isUpdating', false));
    },

    onInputLineItemAmount(amount) {
      this.set('state.amount', amount);
    },

    onInputLineItemDescription(text) {
      this.set('state.description', text);
    },

    closeModal() {
      closeModal(this);
    },
  }
});
